<template>
    <div class="ledger-mgt-filter" :class="{ open: openState}" >
        <div class="ledger-mgt-filter-wrap" v-bind:style="{'height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default">
                <div v-if="isAllGroup" class="title level1-title-font">業務分群</div>
                <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.group">
                    <ul>
                        <li>全部</li>
                        <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                            {{item.groupName}}
                        </li>
                    </ul>
                </rent-select>
                <div class="title  level1-title-font">業務</div>
                <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.member || isGroupChange">
                    <ul>
                        <li>全部</li>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.county">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.district || isCityChange">
                        <ul v-if="filter.county">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default buildin-type">
                <div class="title level1-title-font">記帳類別</div>
                <rent-select refName="type" selectMsg="所有類別" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.type">
                    <ul>
                        <li>所有類別</li>
                        <li data-id="INCOME">
                            收入
                        </li>
                        <li data-id="EXPENSE">
                            支出
                        </li>
                        <li data-id="ADVANCE_PAYMENT">
                            代墊
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div v-if="filter.type" class="default buildin-type">
                <div class="title level1-title-font">記帳項目</div>
                <rent-select class="select-scroll" v-if="filter.type == 'INCOME'" refName="item" selectMsg="請選擇記帳項目" @getId="getSelectId" bgColor="#fff" :setDefault="isTypeChange">
                    <ul>
                        <li v-for="(item, index) in list.ledgerItemIncome" :key="index" :data-id="item.code">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
                <rent-select class="select-scroll" v-if="filter.type == 'EXPENSE'" refName="item" selectMsg="請選擇記帳項目" @getId="getSelectId" bgColor="#fff" :setDefault="isTypeChange">
                    <ul>
                        <li v-for="(item, index) in list.ledgerItemExpense" :key="index" :data-id="item.code">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
                <rent-select class="select-scroll" v-if="filter.type == 'ADVANCE_PAYMENT'" refName="item" selectMsg="請選擇記帳項目" @getId="getSelectId" bgColor="#fff" :setDefault="isTypeChange">
                    <ul>
                        <li v-for="(item, index) in list.ledgerItemAdvencePayment" :key="index" :data-id="item.code">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <!-- <div class="default rent">
                <div class="title level1-title-font">記帳金額</div>
                <vue-slider v-model="filter.amount" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div> -->
            <div class="default date">
                <div class="title level1-title-font">記帳時間</div>
                <date-picker v-model="filter.date" :class="{'active': filter.date != ''}" placeholder="請選擇日期" format="YYYY.MM.DD" range></date-picker>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

import { 
    getLedgerItem,
    } from "@/apis/company/ledger.js"; 

export default {
    data () {
        return {
            openState: this.isOpen,
            filter: {
                group: '',
                member: '',
                county: '',
                district: '',
                type: '',
                item: '',
                amount: [0, 100000],
                date: []
            },
            list: {
                ledgerItemIncome: [],
                ledgerItemExpense: [],
                ledgerItemAdvencePayment: [],
            },
            isCityChange: false,
            isGroupChange: false,
            isTypeChange: false,
            filterState: 0,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        // window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        // this.$store.dispatch('setHouseMgtFilterDefault')
    },
    props: {
        isOpen: Boolean,
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        filter: {
            handler: function (val) {
                this.$store.dispatch('setBizLedgerMgtFilterQuery', val)
                this.filterState = 1
            },
            deep: true
        },
        'filter.type': {
            handler: function (val) {
                this.getLedgetItem(val)
            }
        },
        isDefault: function (val) {
            if(val){
                this.filter = {
                    group: '',
                    member: '',
                    county: '',
                    district: '',
                    type: '',
                    item: '',
                    amount: [0, 100000],
                    date: []
                }
            }
        }
    },
    methods: {
        getLedgetItem: function (data) {
            const params = {
                ledgerType: data
            }
            getLedgerItem(params)
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                    console.table(res.data)
                    if(data == 'INCOME'){
                        this.list.ledgerItemIncome = res.data
                    }else if(data == 'EXPENSE'){
                        this.list.ledgerItemExpense = res.data
                    }else if(data == 'ADVANCE_PAYMENT'){
                        this.list.ledgerItemAdvencePayment = res.data
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            this.filterTop = (scrollTop-163) + 'px'
                
        },
        setFilterDefault: function () {
            this.$store.dispatch('setBizLedgerMgtFilterDefault')
        
            // setTimeout(()=>{
            //     this.filterState = 0
            // },100)
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getSelectId: function (value) {
            this.filterState = 1
            // this.isDefault = false
            if( value.ref == 'orgGroup' ){
                this.filter.group = value.name
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.member = ''
            }else if( value.ref == 'member' ){
                this.filter.member = value.name
                this.isGroupChange = false
            }else if( value.ref == 'county' ){
                this.filter.county = value.name
                this.isCityChange = true
                this.filter.district = ''
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.isCityChange = false
                this.filter.district = value.name
            }else if( value.ref == 'type' ){
                if(value.id){
                    this.filter.type = value.id
                }else{
                    this.filter.type = null
                    this.filter.item = null
                }
                this.isTypeChange = true
            }else if( value.ref == 'item' ){
                this.filter.item = value.id
                this.isTypeChange = false
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // }
    },
    computed: {
        ...mapGetters({
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            isDefault: 'GET_BIZ_LEDGER_MGT_FILTER_DEFAULT'
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .ledger-mgt-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        right: -350px;
        top: 0px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .ledger-mgt-filter-wrap{
            position: relative;
            overflow-x: hidden;
            padding-bottom: 300px;
            &::-webkit-scrollbar {
                display: none;
            }
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    width: 100%;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .ledger-mgt-filter.open{
        right: 0px;
    }
    // @media screen and (max-width: 1280px) {
    //     .ledger-mgt-filter.open{
    //         right: 24px;
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/ledgerMgt/ledgerMgtFilter.vue